import { SubscriptionActionListEnum } from './actionsTypes';

interface SubscriptionPlan {
  id: string;
  name: string;
  price: number;
  durationDays: number;
  features: string[];
  active: boolean;
  createdAt: string;
}

interface UserSubscription {
  id: string;
  userId: string;
  planId: string;
  startDate: string;
  endDate: string;
  status: 'active' | 'expired' | 'cancelled';
  paymentId?: string;
  createdAt: string;
  plan?: SubscriptionPlan;
}

export interface SetCurrentSubscriptionAction {
  type: SubscriptionActionListEnum.SET_CURRENT_SUBSCRIPTION;
  subscription: UserSubscription | null;
  hasSubscription: boolean;
}

export interface SetSubscriptionLoadingAction {
  type: SubscriptionActionListEnum.SET_SUBSCRIPTION_LOADING;
  isLoading: boolean;
}

export interface SetSubscriptionErrorAction {
  type: SubscriptionActionListEnum.SET_SUBSCRIPTION_ERROR;
  error: string | null;
}

export interface ClearSubscriptionAction {
  type: SubscriptionActionListEnum.CLEAR_SUBSCRIPTION;
}

export type SubscriptionActionType = 
  | SetCurrentSubscriptionAction
  | SetSubscriptionLoadingAction
  | SetSubscriptionErrorAction
  | ClearSubscriptionAction;

export const setCurrentSubscriptionAction = (
  subscription: UserSubscription | null,
  hasSubscription: boolean
): SetCurrentSubscriptionAction => ({
  type: SubscriptionActionListEnum.SET_CURRENT_SUBSCRIPTION,
  subscription,
  hasSubscription,
});

export const setSubscriptionLoadingAction = (isLoading: boolean): SetSubscriptionLoadingAction => ({
  type: SubscriptionActionListEnum.SET_SUBSCRIPTION_LOADING,
  isLoading,
});

export const setSubscriptionErrorAction = (error: string | null): SetSubscriptionErrorAction => ({
  type: SubscriptionActionListEnum.SET_SUBSCRIPTION_ERROR,
  error,
});

export const clearSubscriptionAction = (): ClearSubscriptionAction => ({
  type: SubscriptionActionListEnum.CLEAR_SUBSCRIPTION,
});